import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}lud-dashboard/applications`;

// Errors carry the server's machine code and details (missing fields, branch
// problems, ...) so the UI can explain exactly what to fix.
export class ApplicationsApiError extends Error {
  constructor(message, data = {}, status = 0) {
    super(message || "Request failed");
    this.name = "ApplicationsApiError";
    this.status = status;
    this.code = data.code || "";
    this.data = data;
  }
}

const request = async (token, path, { method = "GET", body } = {}) => {
  const response = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new ApplicationsApiError(data.message || data.error, data, response.status);
  }
  return data;
};

const enc = encodeURIComponent;

export const getApplicationsOverviewAPI = (token, storeId) => request(token, `/${enc(storeId)}`);
// One branch across every supported app (shared store account + the branch's own data).
export const getBranchApplicationsAPI = (token, storeId, branchId) => request(token, `/${enc(storeId)}/branches/${enc(branchId)}`);
export const getApplicationDetailAPI = (token, storeId, app) => request(token, `/${enc(storeId)}/${enc(app)}`);
export const previewSubscriptionAPI = (token, storeId, app, body) =>
  request(token, `/${enc(storeId)}/${enc(app)}/subscription/preview`, { method: "POST", body });
export const createSubscriptionAPI = (token, storeId, app, body) =>
  request(token, `/${enc(storeId)}/${enc(app)}/subscription-requests`, { method: "POST", body });
export const subscriptionActionAPI = (token, storeId, requestId, action, body = {}) =>
  request(token, `/${enc(storeId)}/subscription-requests/${enc(requestId)}/${action}`, { method: "POST", body });
export const completeSubscriptionAPI = (token, requestId, note = "") =>
  request(token, `/subscription-requests/${enc(requestId)}/complete`, { method: "POST", body: { note } });
// Integration / activation / deactivation requests (applied only on admin approval).
export const createChangeRequestAPI = (token, storeId, app, body) =>
  request(token, `/${enc(storeId)}/${enc(app)}/requests`, { method: "POST", body });
export const editChangeRequestAPI = (token, storeId, requestId, body) =>
  request(token, `/${enc(storeId)}/requests/${enc(requestId)}`, { method: "PATCH", body });
export const cancelChangeRequestAPI = (token, storeId, requestId) =>
  request(token, `/${enc(storeId)}/requests/${enc(requestId)}/cancel`, { method: "POST", body: {} });
export const reviewChangeRequestAPI = (token, requestId, body) =>
  request(token, `/requests/${enc(requestId)}/review`, { method: "POST", body });
export const integrationDecisionAPI = (token, storeId, app, body) =>
  request(token, `/${enc(storeId)}/${enc(app)}/integration/decision`, { method: "POST", body });
export const getApplicationCredentialsAPI = (token, storeId, app) => request(token, `/${enc(storeId)}/${enc(app)}/credentials`);
export const getApplicationsQueueAPI = (token) => request(token, "/queue");
